import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledIcon = styled('div', {
  position: 'relative',
  color: '$primary2',
  textAlign: 'center',
  fontSize: 20,
  fontWeight: 'bold',
  top: 12,
});

const Container = styled('div', {
  position: 'relative',
  height: 40,
  width: 40,
});

const Triangle = styled('div', {
  width: '100%',
  height: '100%',
  borderTopRightRadius: '30%',
  position: 'absolute',
  backgroundColor: '#FFB808',
  height: 20,
  width: 20,
  top: 10,
  left: 10,

  '&:before, &:after': {
    width: '100%',
    height: '100%',
    borderTopRightRadius: '30%',
    content: '""',
    position: 'absolute',
    backgroundColor: '#FFB808',
  },

  transform: 'rotate(-60deg) skewX(-30deg) scale(1,.866)',
  '&:before': {
    transform:
      'rotate(-135deg) skewX(-45deg) scale(1.414,.707) translate(0,-50%)',
  },
  '&:after': {
    transform: 'rotate(135deg) skewY(-45deg) scale(.707,1.414) translate(50%)',
  },
});

export const ErrorIcon = (props) => {
  return (
    <Container {...props} aria-hidden='true'>
      <Triangle />
      <StyledIcon>!</StyledIcon>
    </Container>
  );
};
